import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'

import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLAdmin, WindowLocationAdmin} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function TradingBuyComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
			DeleteRecord(data.id);
		}
	}
	function DeleteConfirmation(id){
		setAlertcontent({intent:'delete',settings:{id:id,centered:false,icon:'warning',title:'Delete Confirmation!',html:'This process is not ireversible. Once you continue the process, the record will be deleted on the database.',footer:'none'}});
		setalert(true);
	}


	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			account:'',
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/tradingbuy/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/

	/*-------------------------------------------------------------------------
	 Forms: Adding and Updating
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		id:'',
		account:'',
		trade_date:'',
		trade_time:'',
		trade_refnumber:'',
		subscription:'',
		trade_index:'',
		trade_class:'',
		cusip_no:'',
		quantity:'',
		bid_price:'',
		strike_price:'',
		trade_amount:'',
		trade_fees:'',
		trade_total:'',
		status:'',
		submit:'add',
	});
	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let value = {
			id:values.id,
			account:values.account,
			trade_date:values.trade_date!=''?moment(new Date(values.trade_date)).format('YYYY-MM-DD'):'',
			trade_time:values.trade_time,
			trade_refnumber:values.trade_refnumber,
			contact_number:values.contact_number,
			subscription:values.subscription,
			trade_index:values.trade_index,
			trade_class:values.trade_class,
			cusip_no:values.cusip_no,
			quantity:values.quantity,
			bid_price:values.bid_price,
			strike_price:values.strike_price,
			trade_amount:values.trade_amount,
			trade_fees:values.trade_fees,
			trade_total:values.trade_total,
			status:values.status,
		}

		let formData = new FormData();
		formData.append('type',values.submit);
		formData.append('info',JSON.stringify(value));
		axios.post('/admin/tradingbuy/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Data successfully saved."}});
				setalert(true);
				setTimeout(function() {WindowLocationAdmin('/tradingbuy');},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Data not successfully saved. Please try again later.",footer:'yes'}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}



	/*-------------------------------------
	 Delete
	--------------------------------------*/
	function DeleteRecord(id){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Deleting',html:"Deleting record is on process, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','delete');
		formData.append('id',id);
		axios.post('/admin/tradingbuy/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj=='success'){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Record successfully deleted."}});
					setTimeout(function() {
						WindowLocationAdmin('/tradingbuy');
						setalert(false);
					},2000);
				}else{
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Delete Failed',html:"Record not successfully deleted."}});
					setTimeout(function() {setalert(false);},2000);
				}
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
}


	/*-------------------------------------
	 Updating Form
	--------------------------------------*/
	function DetailsData(id){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','details');
		formData.append('id',id);
		axios.post('/admin/tradingbuy/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj==0){
					WindowLocationAdmin('/tradingbuy');
					return false;
				}else{
					setstate({
						...state,
						id:obj.id,
						account:obj.account,
						trade_date:obj.trade_date!=''?moment(new Date(obj.trade_date)).format('MM/DD/YYYY'):'',
						trade_time:obj.trade_time,
						trade_refnumber:obj.trade_refnumber,
						contact_number:obj.contact_number,
						subscription:obj.subscription,
						trade_index:obj.trade_index,
						trade_class:obj.trade_class,
						cusip_no:obj.cusip_no,
						quantity:obj.quantity,
						bid_price:obj.bid_price,
						strike_price:obj.strike_price,
						trade_amount:obj.trade_amount,
						trade_fees:obj.trade_fees,
						trade_total:obj.trade_total,
						status:obj.status,
						submit:'update',
					});
					setalert(false);
					return false;
				}

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	/*-------------------------------------
	 Selection Quries
	--------------------------------------*/
	const [StockExchange, setStockExchange] = useState([]);
	const [ClassTrading, setClassTrading] = useState([]);
	const [StatusTrading, setStatusTrading] = useState([]);
	const [AccountCustomer, setAccountCustomer] = useState([]);



	function SelectionQuries(){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','trading_selection');
		axios.post('/admin/tradingbuy/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setStockExchange(obj.StockExchange);
				setClassTrading(obj.ClassTrading);
				setStatusTrading(obj.StatusTrading);
				setAccountCustomer(obj.AccountCustomer);
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	useEffect(()=>{
		TableList(pagenumber,search);
		SelectionQuries();
		if(props.match.params.id){
			DetailsData(props.match.params.id);
		}
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={insertvalidations}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

						const CustomDate = ({ value, onClick }) => (
							<Input iconPosition='left' onClick={onClick} value={values.trade_date}><Icon name='calendar alternate' /><input /></Input>
						);


						return(
			         <div className="panel hasbottom">
			            <div className="panel-header">Trading Buy</div>
			            <div className="panel-body">


									 <div className="formtwo-wrapper">
									 		<div>

											<div className="inlinformtwo">
 										 		<div><label>Select Client/Member</label></div>
 												<div>
													<Form.Group widths="equal">
														<Field name="account">
															{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<Select selectOnBlur={false}
																				{...field}
																				options={AccountCustomer}
																				onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
															)}
														</Field>
													</Form.Group>
 												</div>
 										 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											 <div><label>Trade Date</label></div>
											 <div>
												 <Form.Group widths="equal">
													<Field name="trade_date">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<DatePicker
																		showYearDropdown
																		yearDropdownItemNumber={100}
																		scrollableYearDropdown
																		showMonthDropdown
																		dropdownMode="select"
																		selected={values.trade_date!=''?new Date(values.trade_date):null}
																		onChange={date => {
																			 var date_selected 	= moment(new Date(date)).format('MM/DD/YYYY');
																			 setFieldValue(field.name,date_selected);
																		}}
																		customInput={<CustomDate />}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
											 </div>
										</div>{/*.inlinform*/}


										<div className="inlinformtwo">
											<div><label>Trade Time</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="trade_time">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

									 <div className="inlinformtwo">
										 <div><label>Trade Ref.No</label></div>
										 <div>
										 <Form.Group widths="equal">
											 <Field name="trade_refnumber">
													 {({ field, form }) => (
													 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <Input {...field} onChange={handleChange}/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
										 </div>
									</div>{/*.inlinform*/}

									<div className="inlinformtwo">
										<div><label>Subscription</label></div>
										<div>
										<Form.Group widths="equal">
											<Field name="subscription">
													{({ field, form }) => (
													<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<Input {...field} onChange={handleChange}/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										</div>
								 </div>{/*.inlinform*/}

								 <div className="inlinformtwo">
									 <div><label>Index</label></div>
									 <div>
										 <Form.Group widths="equal">
											 <Field name="trade_index">
												 {({ field, form }) => (
														 <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <Select selectOnBlur={false}
																	 {...field}
																	 options={StockExchange}
																	 onChange={(e, { value }) => setFieldValue(field.name,value)}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
												 )}
											 </Field>
										 </Form.Group>
									 </div>
								</div>{/*.inlinform*/}

								<div className="inlinformtwo">
									<div><label>Class</label></div>
									<div>
										<Form.Group widths="equal">
											<Field name="trade_class">
												{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Select selectOnBlur={false}
																	{...field}
																	options={ClassTrading}
																	onChange={(e, { value }) => setFieldValue(field.name,value)}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
												)}
											</Field>
										</Form.Group>
									</div>
							 </div>{/*.inlinform*/}

							 <div className="inlinformtwo">
								 <div><label>Cusip No.</label></div>
								 <div>
								 <Form.Group widths="equal">
									 <Field name="cusip_no">
											 {({ field, form }) => (
											 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
												 <Input {...field} onChange={handleChange}/>
												 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
											 </Form.Field>
											 )}
									 </Field>
								 </Form.Group>
								 </div>
							</div>{/*.inlinform*/}

							</div>{/*.left column*/}


										<div>
													<div className="inlinformtwo">
													 <div><label>Quantity</label></div>
													 <div>
													 <Form.Group widths="equal">
														 <Field name="quantity">
																 {({ field, form }) => (
																 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	 <Cleave {...field} options={{numericOnly: true}} onChange={handleChange} maxLength="16"/>
																	 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																 </Form.Field>
																 )}
														 </Field>
													 </Form.Group>
													 </div>
												</div>{/*.inlinform*/}

												<div className="inlinformtwo">
				 								 <div><label>Bid Price</label></div>
				 								 <div>
				 								 <Form.Group widths="equal">
				 									 <Field name="bid_price">
				 											 {({ field, form }) => (
				 											 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
				 												 <Input {...field} onChange={handleChange}/>
				 												 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
				 											 </Form.Field>
				 											 )}
				 									 </Field>
				 								 </Form.Group>
				 								 </div>
				 							</div>{/*.inlinform*/}

											<div className="inlinformtwo">
											 <div><label>Price Per Share	</label></div>
											 <div>
											 <Form.Group widths="equal">
												 <Field name="strike_price">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <Input {...field} onChange={handleChange}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 </div>
										</div>{/*.inlinform*/}

										<div className="inlinformtwo">
										 <div><label>Trade Amount</label></div>
										 <div>
										 <Form.Group widths="equal">
											 <Field name="trade_amount">
													 {({ field, form }) => (
													 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <Cleave {...field} options={{numeral: true,numeralThousandsGroupStyle: 'thousand'}}
														 	onChange={(e) =>{

																var trade_amount = e.target.value;
																var trade_fees   = values.trade_fees;

																if(parseFloat(trade_fees.replace(/,/g, ''))>0){

																	if(trade_amount!=''){
																		var total = parseFloat(trade_amount.replace(/,/g, '')) + parseFloat(trade_fees.replace(/,/g, ''));
 																	  setFieldValue('trade_total',total);
																	}else{
																		setFieldValue('trade_total',trade_fees);
																	}


																}else{
																	 setFieldValue('trade_total',trade_amount);
																}
																setFieldValue(field.name,e.target.value);


															}}
															maxLength="16"/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
										 </div>
									</div>{/*.inlinform*/}

									<div className="inlinformtwo">
									 <div><label>Trade Fees</label></div>
									 <div>
									 <Form.Group widths="equal">
										 <Field name="trade_fees">
												 {({ field, form }) => (
												 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
													 <Cleave {...field} options={{numeral: true,numeralThousandsGroupStyle: 'thousand'}}
													 onChange={(e) =>{

														 var trade_fees = e.target.value;
														 var trade_amount   = values.trade_amount;

														 if(parseFloat(trade_amount.replace(/,/g, ''))>0){

															 if(trade_fees!=''){
																 var total = parseFloat(trade_amount.replace(/,/g, '')) + parseFloat(trade_fees.replace(/,/g, ''));
 																 setFieldValue('trade_total',total);
															 }else{
																 setFieldValue('trade_total',trade_amount);
															 }


														 }else{
																setFieldValue('trade_total',trade_fees);
														 }

														 setFieldValue(field.name,e.target.value);


													 }} maxLength="16"/>
													 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
												 </Form.Field>
												 )}
										 </Field>
									 </Form.Group>
									 </div>
								</div>{/*.inlinform*/}

									<div className="inlinformtwo">
									 <div><label>Trade Total</label></div>
									 <div>
									 <Form.Group widths="equal">
										 <Field name="trade_total">
												 {({ field, form }) => (
												 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
													 <Cleave {...field} options={{numeral: true,numeralThousandsGroupStyle: 'thousand'}} onChange={handleChange} maxLength="16"/>
													 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
												 </Form.Field>
												 )}
										 </Field>
									 </Form.Group>
									 </div>
								</div>{/*.inlinform*/}

								<div className="inlinformtwo">
									<div><label>Status</label></div>
									<div>
										<Form.Group widths="equal">
											<Field name="status">
												{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Select selectOnBlur={false}
																	{...field}
																	options={StatusTrading}
																	onChange={(e, { value }) => setFieldValue(field.name,value)}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
												)}
											</Field>
										</Form.Group>
									</div>
							 </div>{/*.inlinform*/}




								</div>{/*.right column*/}

								</div>{/*.end wrapper*/}


									</div>{/*.panel-body*/}
			            <div className="panel-footer">
									    {values.submit=='update'&&<Button className='red' size='large' icon='close' content='Cancel' href={WindowURLAdmin('/tradingbuy')}/>}
											<Button className='secondary' size='large' icon="save" content={values.submit=='update'?'UPDATE':'SAVE'} onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>

					<div className="panel">
						 <div className="panel-header">Trading Record-Buy</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled singleLine unstackable>
									 <Table.Header>
										 <Table.Row>
										 	 <Table.HeaderCell>Delete</Table.HeaderCell>
										 	 <Table.HeaderCell>Edit</Table.HeaderCell>
											 <Table.HeaderCell>Account</Table.HeaderCell>
											 <Table.HeaderCell>Trade Date</Table.HeaderCell>
											 <Table.HeaderCell>Trade Time</Table.HeaderCell>
											 <Table.HeaderCell>Trade Ref.No.</Table.HeaderCell>
											 <Table.HeaderCell>Subscription</Table.HeaderCell>
											 <Table.HeaderCell>Index</Table.HeaderCell>
											 <Table.HeaderCell>Class</Table.HeaderCell>
											 <Table.HeaderCell>Cusip No.</Table.HeaderCell>
											 <Table.HeaderCell>Quantity</Table.HeaderCell>
											 <Table.HeaderCell>Bid Price</Table.HeaderCell>
											 <Table.HeaderCell>Price Per Share</Table.HeaderCell>
											 <Table.HeaderCell>Trade Amount</Table.HeaderCell>
											 <Table.HeaderCell>Trade Fees</Table.HeaderCell>
											 <Table.HeaderCell>Trade Total</Table.HeaderCell>
											 <Table.HeaderCell>Status</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='17' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key}>
															 <Table.Cell collapsing>
																 <Button className='red' size='small'  icon='trash alternate outline' onClick={()=>DeleteConfirmation(data.id)} />
															 </Table.Cell>
															 <Table.Cell collapsing>
																 <Button className='primary' size='small' icon='edit' as="a" href={WindowURLAdmin('/tradingbuy/'+data.id)}/>
															 </Table.Cell>
															 <Table.Cell>{data.account}</Table.Cell>
															 <Table.Cell>{data.trade_date}</Table.Cell>
															 <Table.Cell>{data.trade_time}</Table.Cell>
															 <Table.Cell>{data.trade_refnumber}</Table.Cell>
															 <Table.Cell>{data.subscription}</Table.Cell>
															 <Table.Cell>{data.trade_index}</Table.Cell>
															 <Table.Cell>{data.trade_class}</Table.Cell>
															 <Table.Cell>{data.cusip_no}</Table.Cell>
															 <Table.Cell>{data.quantity}</Table.Cell>
															 <Table.Cell>{data.bid_price}</Table.Cell>
															 <Table.Cell>{data.strike_price}</Table.Cell>
															 <Table.Cell>{data.trade_amount}</Table.Cell>
															 <Table.Cell>{data.trade_fees}</Table.Cell>
															 <Table.Cell>{data.trade_total}</Table.Cell>
															 <Table.Cell>{data.status}</Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='17'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>
						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
